import api from "@/lib/api";
import { API_BASE } from "@/lib/api";
import { toast } from "sonner";

export function fileUrl(fileId) {
  const token = localStorage.getItem("gf_token");
  return `${API_BASE}/files/${fileId}?auth=${token}`;
}

export async function downloadPdf(path, name) {
  try {
    const res = await api.get(path, { responseType: "blob" });
    const url = URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
    const a = document.createElement("a");
    a.href = url;
    a.download = `${name}.pdf`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 30000);
  } catch (e) {
    toast.error("Impossible de générer le PDF.");
  }
}

export async function downloadExcel(path, name) {
  try {
    const res = await api.get(path, { responseType: "blob" });
    const url = URL.createObjectURL(new Blob([res.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }));
    const a = document.createElement("a");
    a.href = url;
    a.download = `${name}.xlsx`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 30000);
  } catch (e) {
    toast.error("Impossible de générer l'export Excel.");
  }
}

export async function openFile(fileId) {
  try {
    const res = await api.get(`/files/${fileId}`, { responseType: "blob" });
    const url = URL.createObjectURL(res.data);
    const a = document.createElement("a");
    a.href = url;
    a.target = "_blank";
    a.rel = "noopener";
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 60000);
  } catch (e) {
    toast.error("Impossible d'ouvrir le fichier.");
  }
}
